import { render, staticRenderFns } from "./DuplicateEnquiries.vue?vue&type=template&id=20e3702a&scoped=true"
import script from "./DuplicateEnquiries.vue?vue&type=script&lang=js"
export * from "./DuplicateEnquiries.vue?vue&type=script&lang=js"
import style0 from "./DuplicateEnquiries.vue?vue&type=style&index=0&id=20e3702a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e3702a",
  null
  
)

export default component.exports